import { Table } from "antd";
import React from "react";

import SuperAdminContainer from "../SuperAdminContainer";
import GroupsHeader from "./GroupsHeader";
import GroupFilters from "./GroupFilters/GroupFilters";
import NotesManager from "./NotesManager/NotesManager";
import useGroups from "./useGroups";

const Groups = () => {
  const {
    clubs,
    leagues,
    countries,
    isLoading,
    columns,
    membersCount,
    filters,
    handleDropdownChange,
    handleSearchInputChange,
    handleDatePickerChange,
    handleRefresh,
    openNotesModal,
    selectedGroupDetails,
    filteredGroupsList,
    setOpenNotesModal,
    setSelectedGroupDetails,
  } = useGroups();

  return (
    <SuperAdminContainer>
      <div className="superadmin-groups-container">
        <GroupsHeader
          tableData={filteredGroupsList}
          handleRefresh={handleRefresh}
          membersCount={membersCount}
        />

        <GroupFilters
          clubs={clubs}
          leagues={leagues}
          countries={countries}
          filters={filters}
          handleDropdownChange={handleDropdownChange}
          handleSearchInputChange={handleSearchInputChange}
          handleDatePickerChange={handleDatePickerChange}
        />

        <Table
          bordered
          headerBorderRadius={0}
          columns={columns}
          dataSource={filteredGroupsList}
          pagination={{
            position: ["bottomLeft"],
            defaultPageSize: 50,
            showSizeChanger: true,
            pageSizeOptions: [10, 20, 50, 100],
          }}
          sticky={{
            offsetHeader: 0,
            getContainer: () => document.body,
          }}
          scroll={{ x: "max-content" }}
          loading={isLoading}
          rowKey="id"
        />

        <NotesManager
          showModal={openNotesModal}
          setShowModal={setOpenNotesModal}
          groupData={selectedGroupDetails}
          setGroupData={setSelectedGroupDetails}
        />
      </div>
    </SuperAdminContainer>
  );
};

export default Groups;
